import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { MenuItem, Box, TextField, InputAdornment, Icon } from "@mui/material";

function GenderField({ displayName, fieldRef, options }) {
  const [genderChanged, setGenderChanged] = useState(false);
  useEffect(() => {
    if (genderChanged === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [genderChanged]);

  return (
    <Box mt={1}>
      <TextField
        fullWidth
        select
        id={`dff_${fieldRef}`}
        name={fieldRef}
        label={displayName}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>wc</Icon>
            </InputAdornment>
          ),
        }}
        onChange={() => setGenderChanged(!genderChanged)}
      >
        <MenuItem value="M">Male</MenuItem>
        <MenuItem value="F">Female</MenuItem>
      </TextField>
    </Box>
  );
}

// Typechecking props of the Transaction
GenderField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GenderField.defaultProps = {
  options: null,
};
export default GenderField;
